import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://zanox-api.onrender.com";

// Create axios instance WITHOUT proxy
const api = axios.create({
  baseURL: API_URL,
  timeout: 90000,
  // Force direct connection - bypass any proxy
  proxy: false,
});

api.interceptors.request.use(function(config) {
  const token = localStorage.getItem("zanox_token");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
}, function(error) {
  return Promise.reject(error);
});

// Retry failed requests
api.interceptors.response.use(null, async function(error) {
  const config = error.config;
  if (!config || config._retryCount >= 2) return Promise.reject(error);
  config._retryCount = config._retryCount || 0;
  config._retryCount++;
  await new Promise(function(resolve) { setTimeout(resolve, 2000); });
  return api(config);
});

export const sendMessage = async function(message, sessionId) {
  const response = await api.post("/api/ask", { message: message, sessionId: sessionId });
  return response.data;
};

export const uploadImage = async function(imageFile, mode, question, sessionId) {
  const formData = new FormData();
  formData.append("image", imageFile);
  if (mode) formData.append("mode", mode);
  if (question) formData.append("question", question);
  if (sessionId) formData.append("sessionId", sessionId);
  const response = await api.post("/api/vision", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return response.data;
};

export const uploadFile = async function(file, sessionId) {
  const formData = new FormData();
  formData.append("file", file);
  if (sessionId) formData.append("sessionId", sessionId);
  const response = await api.post("/api/file/analyze", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return response.data;
};

export const uploadMultipleImages = async function(imageFiles, mode, sessionId) {
  const formData = new FormData();
  imageFiles.forEach(function(f) { formData.append("images", f); });
  if (mode) formData.append("mode", mode);
  if (sessionId) formData.append("sessionId", sessionId);
  const response = await api.post("/api/vision/multiple", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return response.data;
};

export const readHandwriting = async function(imageFile, sessionId) {
  const formData = new FormData();
  formData.append("image", imageFile);
  if (sessionId) formData.append("sessionId", sessionId);
  const response = await api.post("/api/read-handwriting", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return response.data;
};

export const transcribeAudio = async function(audioBlob, sessionId) {
  const formData = new FormData();
  formData.append("audio", audioBlob, "recording.webm");
  if (sessionId) formData.append("sessionId", sessionId);
  const response = await api.post("/api/voice/transcribe", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return response.data;
};

export const getSessions = async function() {
  const response = await api.get("/api/sessions");
  return response.data;
};

export const getSession = async function(sessionId) {
  const response = await api.get("/api/session/" + sessionId);
  return response.data;
};

export const deleteSession = async function(sessionId) {
  const response = await api.delete("/api/session/" + sessionId);
  return response.data;
};

export const getStats = async function() {
  const response = await api.get("/api/stats");
  return response.data;
};

export const synthesizeSpeech = async function(text) {
  const response = await api.post("/api/voice/synthesize", { text: text });
  return response.data;
};
